<template>
  <div :id="title" :style="styles">
    <div
      v-if="passenger"
      class="passenger-info"
      :class="{ 'second-row': row === 2 }"
    >
      {{ passenger }}
    </div>
  </div>
</template>

<script>
import Vivus from "vivus"
import $ from "jquery"

export default {
  name: "Seat",
  props: {
    title: {
      type: String
    },
    duration: {
      type: Number,
      default: 200
    },
    svg: {
      type: Object
    },
    styles: {
      type: Object
    },
    status: {
      type: String
    },
    passenger: {
      type: String
    },
    row: {
      type: Number
    }
  },
  data() {
    return { vivus: null }
  },
  methods: {
    destroy() {
      if (this.vivus) {
        this.vivus.destroy()
      }
      $(this.$el)
        .find("svg")
        .remove()
    },
    init() {
      // this.destroy()
      this.vivus = new Vivus(this.title, {
        type: "oneByOne",
        duration: this.duration,
        file: this.svg[this.status],
        start: "autostart"
      })
    }
  },
  watch: {
    status: {
      handler() {
        this.destroy()
        this.$nextTick(this.init)
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.destroy()
  }
}
</script>

<style lang="scss" scoped>
.seat {
  position: absolute;
}

.passenger-info {
  position: absolute;
  max-width: 200px;
  top: 50%;
  left: 50%;
  color: #fff;
  font-size: 1rem;
  text-transform: uppercase;
  padding: 12px 15px;
  border-radius: 5px;
  transform: translate(-50%, -50%);
  z-index: 999;

  &.second-row {
    font-size: 0.9rem;
    top: 68%;
    text-align: center;
  }

  @media (max-width: 1200px) {
    display: none;
  }
}
</style>
